import e from "../../hooks/useWindowResize.js";
import t from "../../hooks/useEsc.js";
import n from "../../utils/classNames.js";
import r from "../smoothScrollbars/SmoothScrollbars.js";
import i from "./SidebarFooter.js";
import a from "./SidebarBackdrop.js";
import o from "./SidebarFullscreenToggle.js";
import ee from "./SidebarCloseButton.js";
import s from "../resizer/Resizer.js";
import te from "../../utils/getWidthInBoundaries.js";
import { useEffect as c, useRef as l, useState as u } from "react";
import { noop as d } from "es-toolkit/function";
import { toNumber as f } from "es-toolkit/compat";
import { motion as ne } from "motion/react";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
//#region src/components/sidebars/Sidebar.tsx
var re = 350, ie = 100, ae = 800, g = 0, oe = 400, se = 800, ce = .14, le = 500, _ = {
	LEFT: "left",
	RIGHT: "right"
}, v = {
	MODE_FLY: "fly",
	MODE_FLUID: "fluid"
}, y = {
	sidebarEnter: ({ fromRight: e }) => ({
		x: e ? "100%" : "-100%",
		opacity: 0
	}),
	sidebarVisible: ({ fromRight: e, closed: t }) => ({
		x: t ? e ? "100%" : "-100%" : 0,
		opacity: +!t,
		display: t ? "none" : "block"
	}),
	sidebarExit: ({ fromRight: e }) => ({
		x: e ? "100%" : "-100%",
		opacity: 0
	})
}, b = (x) => {
	let { fly: S = !1, closed: C = !1, title: w = "", footer: T, resizable: E = !1, position: D, width: O = re, minWidth: ue = ie, maxWidth: k = ae, hasBackdrop: de = !1, hasSmoothScrollbar: fe = !1, makeBackdropVisible: pe = !1, enableFullscreenToggle: A = !1, fullscreenToggleTooltip: me, openInFullscreen: he = !1, showHeaderBorder: ge = !1, disableClose: j = !1, bodyRef: M, headerButtons: N, switchModeBreakpoint: P = g, onClose: F = d, onResizeEnd: I = d, onFullScreenChange: L = d, onBackdropClick: _e = d, disableEsc: ve = !1, titleClassName: ye = "", bodyClassName: be = "", headerClassName: xe = "", footerClassName: Se = "", backdropClassName: R = "", className: Ce = "", children: z, ...we } = x, [Te, B] = u(f(O)), [V, H] = u(S ? b.MODE_FLY : b.MODE_FLUID), [U, W] = u(he), [Ee, G] = u(!1), [K, De] = u(!1), [q, Oe] = u(D === _.RIGHT), J = l(null), Y = l(null);
	c(() => {
		J.current && V === b.MODE_FLY && J.current.parentNode?.className.includes("right") && Oe(!0);
	}, [J.current, V]);
	let [X, ke] = u(C);
	X !== C && ke(C);
	let [Ae, je] = u(O);
	Ae !== O && (console.log("update internal width"), B(f(O)), je(O)), e(() => Z(), le), c(() => Z(), []), c(() => {
		C || setTimeout(() => Z());
	}, [C]), c(() => {
		let e = document.querySelector(".module-content");
		e && (Y.current = e);
	}, []), t(() => {
		!ve && A && U && (W(!1), L(!1));
	});
	let Z = () => {
		let e = Y.current?.clientWidth;
		if (S || P === g) return;
		let t = e && e <= oe, n = e && e > se, r = window.innerWidth <= P;
		if (t || r) {
			H(b.MODE_FLY);
			return;
		}
		if (n && !r) {
			H(b.MODE_FLUID);
			return;
		}
	}, Me = (e) => {
		let t = K, n = window.innerWidth * .5, r = k || n;
		B((i) => {
			let a = D === b.RIGHT ? i + e : i - e, o = te(ue, r, a);
			return De(o === n), t && !K ? n : o;
		}), Z();
	}, Ne = () => {
		document.body?.classList.add("pointer-events-none"), G(!0);
	}, Pe = () => {
		document.body?.classList.remove("pointer-events-none"), G(!1), I();
	}, Fe = () => {
		let e = !U;
		W(e), L(e);
	}, Ie = n("Sidebar", Ce, C && "closed", U && "width-100vw sidebar-fullscreen", K && !U && "max-width-50vw width-50vw", V === v.MODE_FLY || U ? "fly" : "fluid"), Le = n("SidebarHeader", xe, ge && "show-border"), Re = n("SidebarTitle", ye), Q = n("SidebarBody", be), ze = n("SidebarResizeLimit", Ee && "display-block"), $ = k || window.innerWidth * .5, Be = /* @__PURE__ */ h(p, { children: [
		/* @__PURE__ */ m("div", {
			className: ze,
			style: q ? { right: $ } : { left: $ }
		}),
		/* @__PURE__ */ h("div", {
			className: "SidebarContent",
			children: [
				/* @__PURE__ */ h("div", {
					className: Le,
					children: [/* @__PURE__ */ m("div", {
						className: Re,
						children: w
					}), /* @__PURE__ */ h("div", {
						className: "SidebarButtons non-printable close",
						children: [
							N,
							A && /* @__PURE__ */ m(o, {
								isFullscreen: U,
								onClick: Fe,
								tooltip: me
							}),
							!j && (N || A) && /* @__PURE__ */ m("div", { className: "SidebarButtons-spacer" }),
							!j && /* @__PURE__ */ m(ee, {
								title: w,
								onClick: F
							})
						]
					})]
				}),
				fe ? /* @__PURE__ */ m(r, {
					slideIn: !0,
					className: Q,
					ref: M,
					children: z
				}) : /* @__PURE__ */ m("div", {
					className: Q,
					ref: M,
					children: z
				}),
				/* @__PURE__ */ m(i, {
					footer: T,
					className: Se
				})
			]
		}),
		E && /* @__PURE__ */ m(s, {
			onResizeStart: Ne,
			onResize: Me,
			onResizeEnd: Pe,
			direction: s.HORIZONTAL,
			position: q ? s.LEFT : s.RIGHT
		})
	] });
	return /* @__PURE__ */ h(p, { children: [/* @__PURE__ */ m(ne.div, {
		...we,
		initial: X && "sidebarEnter",
		animate: "sidebarVisible",
		exit: "sidebarExit",
		variants: y,
		custom: {
			fromRight: q,
			closed: C
		},
		transition: { duration: ce },
		className: Ie,
		style: { width: Te },
		ref: J,
		children: Be
	}), de && !C && /* @__PURE__ */ m(a, {
		className: R,
		makeBackdropVisible: pe,
		onClick: _e
	})] });
};
b.LEFT = _.LEFT, b.RIGHT = _.RIGHT, b.MODE_FLY = v.MODE_FLY, b.MODE_FLUID = v.MODE_FLUID;
//#endregion
export { b as default };

//# sourceMappingURL=Sidebar.js.map